import moment from "moment";

// Set default due date and time to one week from today at noon
const defaultDueDate = moment()
  .hour(12)
  .minute(0)
  .seconds(0)
  .add(7, "days");

// Setting up the default state for the container, so we can import it within
// the component itself as well as any tests

const defaultDevState = {
  userInput: {
    name: {
      val: "TEST",
      isValid: true
    },
    email: {
      val: "dedwards@utk.edu",
      isValid: true
    },
    title: {
      val: "TEST",
      isValid: true
    },
    sport: {
      val: "N/A"
    },
    due: {
      val: defaultDueDate
    },
    description: {
      val: "SOME DESCRIPTION",
      isValid: true
    }
  }
};

const defaultState = {
  userInput: {
    name: {
      val: "",
      isValid: null
    },
    email: {
      val: "",
      isValid: null
    },
    title: {
      val: "",
      isValid: null
    },
    sport: {
      val: "N/A"
    },
    due: {
      val: defaultDueDate
    },
    description: {
      val: "",
      isValid: null
    }
  }
};

export default (process.env.NODE_ENV === "development"
  ? defaultDevState
  : defaultState);



// WEBPACK FOOTER //
// ./src/Video/config/defaultContainerState.js